import React, { forwardRef } from "react"

const cx = (...classes) => classes.filter(Boolean).join(" ")

const variantClassNames = {
  primary: "ui-button--primary",
  secondary: "ui-button--secondary",
  outline: "ui-button--outline",
  ghost: "ui-button--ghost",
  destructive: "ui-button--destructive",
}

const sizeClassNames = {
  sm: "ui-button--sm",
  md: "ui-button--md",
  lg: "ui-button--lg",
}

export const Button = forwardRef(
  (
    {
      as: Component = "button",
      variant = "primary",
      size = "md",
      className,
      children,
      icon,
      iconPosition = "left",
      fullWidth = false,
      type,
      ...props
    },
    ref
  ) => {
    const resolvedType = Component === "button" ? type ?? "button" : undefined
    const classes = cx(
      "ui-button",
      variantClassNames[variant] || variantClassNames.primary,
      sizeClassNames[size] || sizeClassNames.md,
      fullWidth && "ui-button--block",
      className
    )

    return (
      <Component ref={ref} className={classes} type={resolvedType} {...props}>
        {icon && iconPosition === "left" ? icon : null}
        {children}
        {icon && iconPosition === "right" ? icon : null}
      </Component>
    )
  }
)

Button.displayName = "Button"
